// ----------------------------------------------------------------------

function path(root, subLink) {
  return `${root}${subLink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_PATH = '/';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  tiktokCallback: path(ROOTS_AUTH, '/tiktok/callback'),
  register: path(ROOTS_AUTH, '/create-new-account'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  maintenance: '/maintenance',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_PATH,
  home: path(ROOTS_PATH, ''),
  cart: path(ROOTS_PATH, 'cart'),
  search: path(ROOTS_PATH, 'app/search'),
  order: {
    createOrder: path(ROOTS_PATH, `order/create-new`),
    selectAddress: path(ROOTS_PATH, 'order/select-address'),
    addPayment: path(ROOTS_PATH, 'order/add-payment'),
    list: path(ROOTS_PATH, 'order/list'),
    view: path(ROOTS_PATH, 'order/view'),
  },

  me: path(ROOTS_PATH, 'me'),
  product: (id) => path(ROOTS_PATH, `app/product/${id}`),
  general: {
    theme: path(ROOTS_PATH, 'general/theme'),
    language: path(ROOTS_PATH, 'general/language'),
    address: path(ROOTS_PATH, 'general/address'),
    newAddress: path(ROOTS_PATH, 'general/address/new-address'),
    editAddress: (id) => path(ROOTS_PATH, `general/address/edit-address/${id}`),

    account: path(ROOTS_PATH, 'general/my-account'),
  },
};
export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
